import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { isSubmitting } from 'redux-form';
import { Spinner, PRACTICE_URL, makeLocationUrl, } from 'shared';
import * as apiActions from 'api-actions';
import { useLazyGetConsumerApplicationsV2PrequalificationsNewQuery } from 'consumer-applications-v2-api';
import * as actions from '../actions';
import { PracticeSearchForm } from '../forms';
import { selectors } from '../reducer';
function PracticeSearchInput({ setPracticesList, className = '', isSubmitting, setPractice, setPracticeLocations, clearPracticeLocations, getPracticeLocations, practiceLocations, }) {
    // Hooks
    const history = useHistory();
    const { search } = useLocation();
    const [getConsumerApplicationsV2PrequalificationsNew] = useLazyGetConsumerApplicationsV2PrequalificationsNewQuery();
    // Vars
    const query = new URLSearchParams(search);
    const store_number = query.get('store_number');
    useEffect(() => {
        if (store_number) {
            handleSubmit({ adsStoreNumber: store_number });
        }
    }, [store_number]);
    const handleSubmit = async (item) => {
        if (item && item.locationId) {
            setPractice(item);
            //check prequalifications/new response for proveOptOut
            const res = await getConsumerApplicationsV2PrequalificationsNew({
                locationId: item.locationId,
                termsLanguage: 'en',
            });
            if (res.data) {
                const { proveOptOut } = res.data;
                if (!proveOptOut) {
                    history.push({
                        pathname: '/credit-portal/prove',
                        search: `?store=${item.adsStoreNumber}&locationId=${item.locationId}&ref=psi`,
                        state: {
                            practice: item,
                        },
                    });
                }
                else {
                    history.push({
                        pathname: makeLocationUrl(Number(item.locationId)) + `?ref=psi`,
                        state: {
                            practice: item,
                        },
                    });
                }
            }
        }
        else {
            item && item.preventDefault && item.preventDefault();
            return false;
        }
    };
    const handleSubmitSuccess = () => {
        history.push(PRACTICE_URL);
    };
    const handleSubmitFailure = () => {
        setPracticesList(null);
        history.push(PRACTICE_URL);
    };
    return (_jsxs("div", { className: `practice-search-input ${className} `, children: [_jsx(PracticeSearchForm, { displayOptions: {
                    showPrequalify: true,
                    placeholder: 'Practice Name, Address, or Phone Number',
                }, clearPracticeLocations: clearPracticeLocations, getPracticeLocations: getPracticeLocations, setPracticeLocations: setPracticeLocations, onSubmitSuccess: handleSubmitSuccess, onSubmitFail: handleSubmitFailure, handleSubmit: handleSubmit, practiceLocations: practiceLocations }), _jsx("div", { className: "mt-5 spinner", children: isSubmitting && _jsx(Spinner, {}) })] }));
}
function mapStateToProps(state) {
    return {
        isSubmitting: isSubmitting('practiceSearchForm')(state),
        practicesList: selectors.practicesList(state),
        practiceLocations: selectors.practiceLocations(state),
    };
}
const mapDispatchToProps = {
    setPracticesList: actions.setPracticesList,
    setPractice: actions.setPractice,
    clearPracticeLocations: actions.clearPracticeLocations,
    getPracticeLocations: apiActions.getPracticeLocations,
    setPracticeLocations: actions.setPracticeLocations,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(PracticeSearchInput);
